import { render, staticRenderFns } from "./SortMainMenu.vue?vue&type=template&id=4c630e5e&"
import script from "./SortMainMenu.vue?vue&type=script&lang=js&"
export * from "./SortMainMenu.vue?vue&type=script&lang=js&"
import style0 from "./SortMainMenu.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
